import SuggestAddressPage from "../pages/SuggestAddressPage";
import SubmittedAddressPage from "../pages/SubmittedAddressPage";
export {
  SuggestAddressPage,
  SubmittedAddressPage,
};


// WEBPACK FOOTER //
// ./src/routes/external.ts